import About from "../../Portal/Accessor/Project/About";
import Client from "../../Portal/Accessor/Project/Client";
import Plan from "../../Portal/Accessor/Project/Plan";
import Dwelling from "../../Portal/Accessor/Project/Dwelling";
import Projects from "../../Portal/Accessor/Project/Projects";
import Ventilation from "../../Portal/Accessor/Project/Ventilation";
import AnalysisResult from "../../Portal/Accessor/Project/AnalysisResult";
import AnalysisResultDetail from "../../Portal/Accessor/Project/AnalysisResultDetail";
import BatchProcess from "../../Portal/Accessor/Project/BatchProcess";
import BatchProcessProjects from "../../Portal/Accessor/Project/BatchProcessProjects";
import ImportProject from "../../Portal/Accessor/Project/ImportProject";

const AccessorProjectRouters = [
  {
    path: "ProjectAssessor/Projects/:developmentId/:projectId",
    exact: true,
    requireAuth: true,
    element: <Projects />,
    title: "Projects | AccuRate Enterprise",
  },
  {
    path: "ProjectAssessor/Plan/:projectId",
    exact: true,
    requireAuth: true,
    element: <Plan />,
    title: "Plan | AccuRate Enterprise",
  },
  // {
  //   path: "ProjectAssessor/Client/:projectId",
  //   exact: true,
  //   requireAuth: true,
  //   element: <Client />,
  //   title: "Client | AccuRate Enterprise",
  // },
  {
    path: "ProjectAssessor/Dwelling/:projectId",
    exact: true,
    requireAuth: true,
    element: <Dwelling />,
    title: "Dwelling | AccuRate Enterprise",
  },
  {
    path: "ProjectAssessor/Detail/:developmentId/:projectId",
    exact: true,
    requireAuth: true,
    element: <About />,
    title: "About | AccuRate Enterprise",
  },
  {
    path: "ProjectAssessor/ImportProject",
    exact: true,
    requireAuth: true,
    element: <ImportProject />,
  },
  {
    path: "VentilationAssessor/Detail/:projectId/:designVariationId",
    exact: true,
    requireAuth: true,
    element: <Ventilation />,
    title: "Orientation | AccuRate Enterprise",
  },
  {
    path: "AnalysisResultAssessor/Analysises/:designVariationVersionName/:projectId",
    exact: true,
    requireAuth: true,
    element: <AnalysisResult />,
    title: "Analysis | AccuRate Enterprise",
  },
  {
    path: "AnalysisResultAssessor/Detail/:designVariationVersionName/:projectId/:designVariationId",
    exact: true,
    requireAuth: true,
    element: <AnalysisResultDetail />,
    title: "Analysis Result | AccuRate Enterprise",
  },
  {
    path: "BatchProcess/Detail/:projectId/:designVariationId/:redirectUrlHex",
    exact: true,
    requireAuth: true,
    element: <BatchProcess />,
  },
  {
    path: "BatchProcessProjects/Detail/:projectIdsJsonCode/:redirectUrlHex",
    exact: true,
    requireAuth: true,
    element: <BatchProcessProjects />,
  },
];
export default AccessorProjectRouters;
